<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="'left'">
    <el-form-item label="Documento" label-width="100px" class="mb-4" prop="ndocument">
        <el-input placeholder="Nro documento" v-model="ruleForm.ndocument" :maxlength="maxlength" @keypress.native="isNumber($event)" class="input-with-select" size="medium" :clearable="true">
            <el-select v-model="ruleForm.tdocument" slot="prepend" placeholder="Seleccione" @change="ruleForm.ndocument=''">
                <el-option v-for="item in listDocument" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
        </el-input>
    </el-form-item>

    <el-form-item label="Nombres" label-width="100px" prop="firstname">
        <el-input v-model="ruleForm.firstname" placeholder="Nombres y apellidos completos" size="medium"></el-input>
    </el-form-item>
    <el-form-item label="Celular" label-width="100px" prop="phone">
        <el-input v-model="ruleForm.phone" size="medium" maxlength="9" @keypress.native="isNumber($event)"></el-input>
    </el-form-item>
    <el-form-item label="Email" label-width="100px" prop="email">
        <el-input v-model="ruleForm.email" placeholder="Correo electrónico" size="medium"></el-input>
    </el-form-item>
    <el-form-item prop="terms">
        <el-checkbox v-model="ruleForm.terms">He leído y acepto los
            <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
    </el-form-item>

    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('ruleForm')">Ir a pagar</button>

</el-form>
</template>

<script>
import data from "@/data/common";

export default {
    data() {
        var validateDocument = (rule, value, callback) => {
            if (this.ruleForm.tdocument == '01' && value.length < 8)
                return callback(new Error('DNI son 8 dígitos'))
            else if (this.ruleForm.voucher == 'F' && value.length < 10)
                return callback(new Error('RUC son 11 dígitos'))
            else
                return callback()
        }
        return {
            ruleForm: {
                tdocument: '01',
                ndocument: null,
                firstname: null,
                phone: null,
                email: null,
                terms: null
            },
            rules: {
                ndocument: [{
                    required: true,
                    message: 'Falta número de documento',
                    trigger: ['blur', 'change']
                }, {
                    validator: validateDocument,
                    trigger: ['change', 'blur']
                }],
                firstname: [{
                    required: true,
                    message: 'Falta nombres completos',
                    trigger: 'blur'
                }],
                phone: [{
                    required: true,
                    message: 'Falta celular',
                    trigger: 'blur'
                }],
                email: [{
                    required: true,
                    message: 'Falta ingresar correo electrónico',
                    trigger: ['blur', 'change']
                }, {
                    type: 'email',
                    message: 'Ingrese dirección de correo electrónico correcta',
                    trigger: ['blur', 'change']
                }],
                terms: [{
                    required: true,
                    message: 'Falta aceptar y condiciones',
                    trigger: ['blur', 'change']
                  }
                ]
            },
            listDocument: data.document,
        }
    },
    computed: {
        maxlength: function () {
            return (this.ruleForm.tdocument == '01' || this.ruleForm.voucher == 'B') ? 8 : 11
        }
    },
    methods: {
        isNumber(evt) {
            if (this.ruleForm.tdocument == '01')
                if (!/^[0-9]+$/.test(evt.key) || evt.key === '.') return evt.preventDefault();
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid){
                    this.$emit("update:loading", true)
                    this.$emit("getWizard3", this.ruleForm)
                }
            })
        }

    }

}
</script>



// WEBPACK FOOTER //
// src/components/pages/camping/wizard3.vue